import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiContact\UpdateWikiContactController::__invoke
* @see app/Http/Controllers/WikiContact/UpdateWikiContactController.php
* @route '/api/wiki-contact/{contact}'
*/
const UpdateWikiContactController = (args: { contact: string | { id: string } } | [contact: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateWikiContactController.url(args, options),
    method: 'put',
})

UpdateWikiContactController.definition = {
    methods: ["put"],
    url: '/api/wiki-contact/{contact}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\WikiContact\UpdateWikiContactController::__invoke
* @see app/Http/Controllers/WikiContact/UpdateWikiContactController.php
* @route '/api/wiki-contact/{contact}'
*/
UpdateWikiContactController.url = (args: { contact: string | { id: string } } | [contact: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { contact: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { contact: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            contact: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        contact: typeof args.contact === 'object'
        ? args.contact.id
        : args.contact,
    }

    return UpdateWikiContactController.definition.url
            .replace('{contact}', parsedArgs.contact.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiContact\UpdateWikiContactController::__invoke
* @see app/Http/Controllers/WikiContact/UpdateWikiContactController.php
* @route '/api/wiki-contact/{contact}'
*/
UpdateWikiContactController.put = (args: { contact: string | { id: string } } | [contact: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateWikiContactController.url(args, options),
    method: 'put',
})

export default UpdateWikiContactController